import "../../css/dashboardIA.css";

// Titular del bloque 1 (RF-7). Un número es un número: SIN gráfica. `valor` ya viene formateado por el
// caller con `fmt()` (RF-27d): puede ser un entero o "—". `sub`, si viene, siempre es texto — el `tono`
// del punto solo refuerza, nunca reemplaza la etiqueta (el estado nunca se comunica solo con color).
const StatTile = ({ label, valor, icono, sub, tono }) => (
  <div className="dia-stat">
    <div className="dia-stat__icono">
      {icono && <i className={`fa ${icono}`} aria-hidden="true"></i>}
    </div>
    <div className="dia-stat__cuerpo">
      <span className="dia-stat__valor">{valor}</span>
      <span className="dia-stat__label">{label}</span>
      {sub && (
        <span className="dia-stat__sub">
          {tono && <span className={`dia-stat__dot dia-stat__dot--${tono}`} aria-hidden="true"></span>}
          {sub}
        </span>
      )}
    </div>
  </div>
);

export default StatTile;
